import axios from "../../../../../utils/axiosInceptor";
import * as action_types from "./constants";
import { maintenanceService } from "../../../../../configs/constants";
import { message } from "antd";

const ticketsUrlNew = `${maintenanceService}/maintenance/getTickets?`;
const singleTicketsUrlNew = `${maintenanceService}/maintenance/getTicket`;

const ticketsTypeUrl = `${maintenanceService}/maintenance/serviceprovider/building/category?`;
const ticketTypeAddTicket = `${maintenanceService}/maintenance/landlord/serviceprovider/category/`;
const ticketsSubTypeUrl = `${maintenanceService}/facilityManager/fetchTicketCategoryChildren`;

const ticketsCountUrl = `${maintenanceService}/facilityManager/getTicketsCount`;

const propertyUrl = `${maintenanceService}/property/serviceProviderPropertyList`; //changed

const techUrl = `${maintenanceService}/maintenance/technician/eligibleTechnician`;

const technicianUrl = `${maintenanceService}/maintenance/technician`;

const maintananceUrl = `${maintenanceService}/maintenance`;

const availableUrl = `${maintenanceService}/maintenance/getAvailablity`;

const ticketsStatusTypeUrl = `${maintenanceService}/maintenance/getTickets`;

export const getTicketType = (param, type = null) => {
  return async (dispatch) => {
    try {
      let params = new URLSearchParams({
        ...param,
      });

      let endPoint = param?.type === "addTicket" ? ticketTypeAddTicket : ticketsTypeUrl;

      let queryParams = param?.type === "addTicket" ? param?.property : params.toString();

      const {
        data: { result },
      } = await axios.get(endPoint + queryParams);
      dispatch({
        type: action_types.TICKETS_TYPE,
        data: result,
      });
    } catch (e) {
      console.log("Err", e);
    }
  };
};

export const patchTicket = async (ticketId: string, data) => {
  try {
    const url = `${maintenanceService}/maintenance/ticket/${ticketId}`;
    return await axios.patch(url, data);
  } catch (error) {
    console.log("Error", error);
    throw error;
  }
};

export const getTicketSubType = (param) => {
  return async (dispatch) => {
    try {
      const {
        data: { result },
      } = await axios.post(ticketsSubTypeUrl, { category_id: param });
      dispatch({
        type: action_types.TICKETS_SUB_TYPE,
        data: result,
      });
    } catch (e) {
      console.log("Err", e);
    }
  };
};

export const getAvailableTechnicians = async (params) => {
  return await axios.post(`${technicianUrl}/available`, params);
};

export const assignAvailableTechnicians = async (technicianId, params) => {
  return await axios.patch(`${maintananceUrl}/ticketReassign/${technicianId}`, params);
};

// new function to just return the data, don't need to to add to redux
// data will be displayed on tenant -> view file -> tickets.

export const getTicketsForTenant = async (page, param: any = {}) => {
  try {
    let params = new URLSearchParams({
      ticketStatus: param.ticketStatus,
      page: page,
      ...param,
    });
    const {
      data: { result },
    } = await axios.get(ticketsUrlNew + params.toString());
    return result;
  } catch (e) {
    console.log("Err", e);
  }
};

export const getNewTicket = (page, param = {}) => {
  return async (dispatch) => {
    try {
      let params = new URLSearchParams({
        ticketStatus: "new",
        page: page,
        ...param,
      });
      const {
        data: { result },
      } = await axios.get(ticketsUrlNew + params.toString());
      dispatch({
        type: action_types.TICKETS_NEW,
        data: result,
      });
    } catch (e) {
      console.log("Err", e);
    }
  };
};

export const getInprogressTicket = (page, param = {}) => {
  return async (dispatch) => {
    try {
      let params = new URLSearchParams({
        ticketStatus: "inProgress",
        acknowledged: "no",
        page: page,
        ...param,
      });
      const {
        data: { result },
      } = await axios.get(ticketsUrlNew + params.toString());
      dispatch({
        type: action_types.TICKETS_PROGRESS,
        data: result,
      });
    } catch (e) {
      console.log("Err", e);
    }
  };
};

export const getAcknowledgedTicket = (page, param = {}) => {
  return async (dispatch) => {
    try {
      let params = new URLSearchParams({
        ticketStatus: "inProgress",
        acknowledged: "yes",
        page: page,
        ...param,
      });
      const {
        data: { result },
      } = await axios.get(ticketsUrlNew + params.toString());
      dispatch({
        type: action_types.TICKETS_ACKNOWLEDGED,
        data: result,
      });
    } catch (e) {
      console.log("Err", e);
    }
  };
};

export const getClosedTicket = (page, param = {}) => {
  return async (dispatch) => {
    try {
      let params = new URLSearchParams({
        ticketStatus: "completed",
        page: page,
        ...param,
      });
      const {
        data: { result },
      } = await axios.get(ticketsUrlNew + params.toString());
      dispatch({
        type: action_types.TICKETS_CLOSED,
        data: result,
      });
    } catch (e) {
      console.log("Err", e);
    }
  };
};

export const exportTickets = (page, param = {}) => {
  return async (dispatch) => {
    try {
      let params = new URLSearchParams({
        ticketStatus: "completed",
        page: page,
        ...param,
      });
      const {
        data: { result },
      } = await axios.get(ticketsUrlNew + params.toString());
      dispatch({
        type: action_types.TICKETS_CLOSED,
        data: result,
      });
    } catch (e) {
      console.log("Err", e);
    }
  };
};

export const getInprogressCount = (param = {}) => {
  return async (dispatch) => {
    try {
      const {
        data: { result },
      } = await axios.get(`${ticketsCountUrl}?status=inProgress`, {
        params: param,
      });
      dispatch({
        type: action_types.TICKETS_COUNT_PROGRESS,
        data: result,
      });
    } catch (e) {
      console.log("Errr", e);
    }
  };
};

export const getClosedCount = (param = {}) => {
  return async (dispatch) => {
    try {
      const {
        data: { result },
      } = await axios.get(`${ticketsCountUrl}?status=completed`, {
        params: param,
      });
      dispatch({
        type: action_types.TICKETS_COUNT_CLOSED,
        data: result,
      });
    } catch (e) {
      console.log("Err", e);
    }
  };
};

export const getNewTicketStatusType = () => {
  return async (dispatch) => {
    try {
      const {
        data: { result },
      } = await axios.get(`${ticketsStatusTypeUrl}?ticketStatus=new`);
      dispatch({
        type: action_types.TICKETS_NEW_STATUS_TYPE,
        data: result,
      });
    } catch (e) {
      console.log("Err", e);
    }
  };
};

export const getProgressTicketStatusType = () => {
  return async (dispatch) => {
    try {
      const {
        data: { result },
      } = await axios.get(`${ticketsStatusTypeUrl}?status=inProgress`);
      dispatch({
        type: action_types.TICKETS_PROGRESS_STATUS_TYPE,
        data: result,
      });
    } catch (e) {
      console.log("Err", e);
    }
  };
};

export const getClosedTicketStatusType = () => {
  return async (dispatch) => {
    try {
      const {
        data: { result },
      } = await axios.get(`${ticketsStatusTypeUrl}?status=completed`);
      dispatch({
        type: action_types.TICKETS_CLOSED_STATUS_TYPE,
        data: result,
      });
    } catch (e) {
      console.log("Err", e);
    }
  };
};

export const getPropertyName = (isUnitWant = false) => {
  return async (dispatch) => {
    let endPoint = isUnitWant ? `${propertyUrl}?${isUnitWant}` : propertyUrl;
    try {
      const {
        data: { result },
      } = await axios.get(endPoint);
      dispatch({
        type: action_types.PROPERTY_NAME,
        data: result,
      });
    } catch (e) {
      console.log("Err", e);
    }
  };
};

export const getTechnicians = (body) => {
  return async (dispatch) => {
    try {
      const {
        data: { result },
      } = await axios.post(techUrl, body);
      dispatch({
        type: action_types.ELIGIBLE_TECHNICIAN,
        data: result,
      });
    } catch (e) {
      console.log("Err", e);
    }
  };
};

export const getAvailablity = (body) => {
  return async (dispatch) => {
    try {
      const {
        data: { result },
      } = await axios.get(availableUrl, {
        params: body,
      });
      dispatch({
        type: action_types.AVAILABLE_SLOTS,
        data: result,
      });
    } catch (e) {
      console.log("Err", e);
      message.error(e?.response?.data?.error);
      dispatch({
        type: action_types.AVAILABLE_SLOTS,
        data: [],
      });
    }
  };
};

// maintenance/getAvailablity?propertyId=propertyId-f9a5a80b-e9bc-4938-be14-1ccb5c9f0f3e
// &categoryId=categoryId-552f6758-c9db-43e7-ac29-905158859d53
// &timeInMin=30
// &startDate=2023-04-07'

export const resetTechnician = () => {
  return (dispatch) => {
    dispatch({
      type: action_types.RESET_TECHNICIAN,
      data: [],
    });
  };
};

// export const getPresignedImage = (mediaArray) => {
//   return async (dispatch) => {
//     try {
//       const result = await apiIterator(mediaArray);
//       console.log('I AM A RESULTER', result);
//       dispatch({
//         type: action_types.PRESIGNED_IMAGE,
//         data: result,
//       });
//     } catch (e) {
//       console.log("Err", e);
//     }
//   };
// };
// documentId_ebcec933-d641-48b3-ad72-807b0510cb36
//  '/documentId_ebcec933-d641-48b3-ad72-807b0510cb36?expiresIn=600'
// organization-unit: AGP' \   -H 'bussiness-unit: AUTO' \   -H 'channel: MOBILE' \   -H 'accept-language: EN' \   -H 'source: Orion

//   if (config.url.includes('ms/document'))
// {      config.headers['accept-language'] = 'EN';
//      config.headers['source'] = Config.SOURCE;
//    config.headers['channel'] = Config.CHANNEL;
//   config.headers['accept'] = 'application/json';
//   config.headers['Content-Type'] = 'multipart/form-data';
//      config.headers['bussiness-unit'] = Config.BUSINESS_UNIT;
//      config.headers['organization-unit'] = Config.ORGANIZATION_UNIT;
//   }

// SOURCE = Orion
// ENV = production
// CHANNEL = MOBILE
// APP_NAME = tenantApp
// BUSINESS_UNIT = AUTO
// ORGANIZATION_UNIT = AGP
// MEDIA_URL = https://document-api.agp-dev.com/
// BASE_URL = https://eqarcom-gateway-api.agp-dev.com/api/v1/

export const getTicketReviews = (param) => {
  return async (dispatch) => {
    try {
      const {
        data: { result },
      } = await axios.get(`${maintenanceService}/facilityManager/getTicketReviews`, { params: { caseId: param } });
      dispatch({
        type: action_types.TICKETS_REVIEWS,
        data: result,
      });
    } catch (e) {
      console.log("Err", e);
    }
  };
};

export const getTicketByID = (id) => {
  return async (dispatch) => {
    try {
      const {
        data: { result },
      } = await axios.get(`${singleTicketsUrlNew}/${id}`);
      dispatch({
        type: action_types.TICKET_BY_ID,
        data: result,
      });
    } catch (e) {
      console.log("Err", e);
    }
  };
};

export const getOrgByID = (orgId) => {
  return async (dispatch) => {
    try {
      const {
        data: { result },
      } = await axios.get(`${maintenanceService}/organization/${orgId}`); ///organization/orgId-eb9dccfb-325e-4c5f-a306-7842789f75fd'
      dispatch({
        type: action_types.ORG_BY_ID,
        data: result,
      });
    } catch (e) {
      console.log("Err", e);
    }
  };
};

export const getPropertyUnits = (property_id) => {
  return async (dispatch) => {
    try {
      const {
        data: { result },
      } = await axios.get(`${maintenanceService}/unit/unitDropDown/${property_id}`);
      dispatch({
        type: action_types.GET_PROPERTY_UNITS,
        data: result,
      });
    } catch (e) {
      console.log("Err", e);
    }
  };
};

export const emptyTickets = () => {
  return (dispatch) => {
    dispatch({
      type: action_types.EMPTY_TICKETS,
      data: null,
    });
  };
};

// export const getTicketsExport = (param) => {
//   return async (dispatch) => {
//     try {
//       const {
//         data: { result },
//       } = await axios.get(`${maintenanceService}/maintenance/export`, param);
//       dispatch({
//         type: action_types.TICKETS_EXPORT,
//         data: result,
//       });
//     } catch (e) {
//       console.log("Err", e);
//     }
//   };
// };
